import { connect } from 'react-redux'
import { getToken } from 'services/token/reducer'

const mapStateToProps = (state) => {
    return {
        tokenLoading: state?.token?.loading ?? true,
    }
}

const hocConnect = (InnerComponent) => connect(mapStateToProps, { getToken })(InnerComponent)

export default hocConnect
